import { render, staticRenderFns } from "./WProductVariant.vue?vue&type=template&id=02906570&scoped=true&"
import script from "./WProductVariant.vue?vue&type=script&lang=js&"
export * from "./WProductVariant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02906570",
  null
  
)

export default component.exports

/* vue-automatic-import-loader */
import autoInstallComponents from "!/Users/waltergammarota/Documents/Trabajo/Orsai/casciari-admin/node_modules/vue-automatic-import-loader/lib/runtime/autoInstallComponents.js"
import WImageUploadLittle from '@/components/WImageUploadLittle.vue'
import WInput from '@/components/WInput.vue'
import WInputNumber from '@/components/WInputNumber.vue'
autoInstallComponents(component, {WImageUploadLittle,WInput,WInputNumber})
